export const LiveIndicator = ({ label = 'LIVE' }) => {
  return (
    <div className="live-indicator" data-testid="live-indicator">
      <span className="live-dot"></span>
      <span className="text-xs font-mono text-green-400 uppercase tracking-wider">{label}</span>
    </div>
  );
};
